import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';

@Component({
  selector: 'app-dealer-searchbox-dropdown',
  templateUrl: './dealer-searchbox-dropdown.component.html'
})
export class DealerSearchboxDropdownComponent implements OnInit {
  @Input() dealerList: SelectListItemViewModel[];
  @Input() classes: string = '';
  @Input() clear: boolean = true;
  @Input() disabled: boolean = false;
  selectedDealer: string;
  @Input('selectedDealer')
  set in(val) {
    if(val==='')
      this.selectedDealer=undefined
    else
      this.selectedDealer = val;
  }

  @Output() onSelectDealer = new EventEmitter<string>();

  selectedDealerId: string;

  ngOnInit(): void {
    // This is intentional
  }

  setDealer(_event: any) {
    this.selectedDealerId=this.selectedDealer;
    this.onSelectDealer.emit(this.selectedDealerId);
  }
}
